export default __webpack_public_path__ + "static/industry-utilities-2693c61152025999c08a720d7d2b15cd.jpg";